import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    chartConfig,
    chartConfigurator,
} from '../../utilities/ChartConfig';
import 'chartjs-plugin-annotation';
import 'chartjs-plugin-style';

const TopIndicesChart = ({ values }) => {

    const config = chartConfig();
    chartConfigurator.setup(config);

    chartConfigurator.addValues(values, function (value) {
        return {
            x: new Date(value.asAt),
            y: value.amount,
        };
    });

    config.options.scales.xAxes[0].time.stepSize = 7;
    config.options.scales.xAxes[0].time.displayFormats.day = 'DD MMM';

    config.options.scales.xAxes[0].ticks.maxTicksLimit = 4;
    config.options.scales.yAxes[0] = [{
        gridLines: {
            color: '#eeeef0',
            drawBorder: false,
            tickMarkLength: 0,
        },
        ticks: {
            maxTicksLimit: 5,
            callback: function (label) {
                return (label).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            },
            padding: 10,
        },
    }];

    config.options.tooltips.caretPadding = 5;
    config.options.tooltips.bodyFontColor = '#222222';

    config.plugins[1] = {
        afterDraw: function (chart) {
            const ctx = chart.chart.ctx; // eslint-disable-line prefer-destructuring
            const xAxis = chart.scales['x-axis-0'];
            const yAxis = chart.scales['y-axis-0'];

            ctx.beginPath();
            ctx.moveTo(xAxis.left, yAxis.bottom);
            ctx.lineTo(xAxis.right, yAxis.bottom);
            ctx.lineWidth = 3;
            ctx.strokeStyle = '#DFE0E3';
            ctx.stroke();
        },
    };

    return (
        <div className="chart-container">
            <Line {...config} />
        </div>
    );
};
export default TopIndicesChart;
